/** Auto-generated */
export const landingUnsupportedJa = {
  paymentSuccess: {
    seo: {
      title: 'お支払いが完了しました - Veeso AI',
    },
    hero: {
      title: 'お支払いが完了しました！',
      description: 'ご購入ありがとうございます。サブスクリプションが正常に有効化されました。',
    },
    checkout_id_label: 'ID：',
    cta: {
      continue: '中断したところから再開する',
      dashboard: 'ダッシュボードへ',
      home: 'ホームに戻る',
    },
    footer: {
      need_help: 'サポートが必要ですか？',
      contact: 'サポートに問い合わせる',
    },
  },
  auth: {
    callback: {
      seo: {
        title: '認証中... - Veeso AI',
      },
      loading: '認証中です。しばらくお待ちください...',
    },
  },
  error: {
    seo: {
      title_404: '404 - ページが見つかりません | Veeso AI',
      title_generic: 'エラー | Veeso AI',
    },
    title_404_line1: '迷い込みました',
    title_404_line2: '虚空の中へ',
    title_generic_line1: '何かが',
    title_generic_line2: 'うまくいきませんでした',
    desc_404: 'お探しのページは存在しないか、移動されました。もとの場所にお戻りいただけます。',
    desc_generic_fallback: '予期しないエラーが発生しました。',
    cta: {
      home: 'ホームに戻る',
    },
    dev: {
      toggle: 'エラー詳細（開発モード）',
    },
  },
  legal: {
    privacy: {
      page: {
        last_updated: '最終更新日：2025 年 12 月 27 日',
      },
    },
    cookie: {
      page: {
        last_updated: '最終更新日：2026 年 3 月 6 日',
      },
    },
  },
  aiToolsIndex: {
    empty_state: 'まだ利用可能な AI ツールはありません。後ほど再度ご確認ください！',
    card: {
      cta: 'ジェネレーターを試す',
    },
    seo_content: {
      hero: {
        title: 'なぜ Veeso AI を選ぶのか？',
        subtitle: '画像を生成するのはもうやめましょう。デザインを生成しましょう。',
      },
      compare: {
        traditional: {
          title: '従来の AI 画像ツール',
          items: [
            '静的な画像',
            'コンテンツ階層なし',
            'テキストの修正が困難',
            '実用レベルではない',
            'ワンショット生成のみ',
            'エクスポート形式が限定的',
            '編集にデザインスキルが必要',
            '固定サイズのみ',
            'バージョン管理なし',
            'コンテンツの長さに対応不可',
            '複数ページ非対応',
            '編集プロセスに時間がかかる',
            'ブランド一貫性ツールなし',
          ],
        },
        veeso: {
          title: 'Veeso AI',
          items: [
            '構造化されたレイアウト',
            '明確なレイアウト構造',
            '完全に編集可能なレイヤー',
            '実際の公開を想定して設計',
            '自由に編集・調整・エクスポート可能',
            '複数のエクスポート形式に対応',
            'コンテンツファーストのワークフロー',
            'デザインスキル不要',
            '柔軟なサイズ設定',
            '繰り返しの調整が可能',
            'コンテンツに自動で適応',
            '複数ページレイアウト対応',
            '高速な編集ワークフロー',
            'ブランド一貫性機能',
          ],
        },
      },
    },
  },
  blog: {
    index: {
      seo: {
        title: '学ぶ＆ブログ - Veeso AI',
      },
      hero: {
        title: '学ぶ＆ブログ',
      },
      card: {
        read_more: '続きを読む',
      },
      image_alt_fallback: 'ブログ記事の画像',
      faq: {
        items: [
          {
            question: '「学ぶ＆ブログ」セクションではどのようなトピックが扱われていますか？',
            answer:
              '「学ぶ＆ブログ」セクションでは、AI デザインのベストプラクティス、コンテンツ制作戦略、マーケティングのヒント、デザインチュートリアル、ケーススタディ、Veeso AI を効果的に使う方法など、幅広いトピックを扱っています。より良いデザインの作成とワークフロー改善に役立つ記事を定期的に公開しています。',
          },
          {
            question: '新しい記事はどのくらいの頻度で公開されますか？',
            answer:
              'AI デザインの最新トレンド、ヒント、ベストプラクティスをお届けするため、定期的に新しい記事を公開しています。新着コンテンツをお見逃しなく、ぜひ頻繁にチェックしてください。',
          },
          {
            question: '今後のブログ記事のトピックを提案できますか？',
            answer:
              'はい！取り上げてほしいトピックのご提案を歓迎します。お問い合わせページや SNS からお気軽にアイデアをお送りください。',
          },
          {
            question: 'チュートリアルは初心者にも適していますか？',
            answer:
              'もちろんです！チュートリアルは初心者から経験豊富なデザイナーまで、あらゆるスキルレベルに対応しています。各チュートリアルにはステップバイステップの手順とわかりやすい説明が含まれています。',
          },
          {
            question: '「学ぶ＆ブログ」セクションの記事を共有できますか？',
            answer:
              'はい、記事の共有は大歓迎です！SNS やチーム内での共有を推奨しています。各記事には便利な共有ボタンも用意されています。',
          },
          {
            question: '記事には実践的な例が含まれていますか？',
            answer:
              'はい！記事には実際の事例、ケーススタディ、すぐに使える実践的なヒントが含まれることが多く、実践に活かせる内容を重視しています。',
          },
          {
            question: '新しいブログ記事の最新情報を受け取るには？',
            answer:
              '「学ぶ＆ブログ」セクションを定期的にチェックいただくか、新着記事をお知らせする SNS をフォローいただくことで最新情報を受け取れます。また、簡単にアクセスできるようページをブックマークしておくこともおすすめです。',
          },
          {
            question: 'ビデオチュートリアルはありますか？',
            answer:
              'ブログは主に文章コンテンツとチュートリアルが中心ですが、動画コンテンツや動画リソースへのリンクを含む記事もあります。各記事でマルチメディアコンテンツをご確認ください。',
          },
          {
            question: '記事のデザイン例を自分のプロジェクトで使用できますか？',
            answer:
              'はい！記事で紹介する例やテンプレートは、ご自身のプロジェクトのインスピレーションとして自由にご活用いただけます。コンセプトやアイデアをご自身のニーズに合わせてアレンジしてください。',
          },
          {
            question: '特定のトピックの記事を探すには？',
            answer:
              '「学ぶ＆ブログ」ページをスクロールして記事を閲覧できます。記事は時系列順に整理されており、検索機能（利用可能な場合）やカテゴリータグでの絞り込みで、特定のトピックのコンテンツを見つけられます。',
          },
        ],
      },
    },
  },
  spotlight: {
    index: {
      seo: {
        title_fallback: 'スポットライト - Veeso AI',
      },
      hero: {
        title_fallback: 'スポットライト',
      },
      card: {
        read_more: '続きを読む',
      },
      empty_state: 'まだスポットライト記事はありません。後ほど再度ご確認ください！',
    },
  },
  common: {
    error: 'エラー',
  },
  language_switcher: {
    aria_label: '言語',
  },
  pricing: {
    breadcrumb: {
      home: 'ホーム',
      pricing: '料金',
    },
  },
  help: {
    getting_started: {
      ui_terms:
        'UI ボタン名は英語のまま保持（Sign Up、Create、Generate、Export など）し、文脈で日本語の説明を補う',
    },
  },
};
export const landingUnsupportedInviteJa = {
  seo: {
    title: '友達を招待する | Veeso AI 紹介プログラム',
  },
  title: '友達を招待する',
  subtitle: 'あなたと友達の両方が 200 クレジットを受け取れます。',
  description: 'あなたと友達の両方が 200 クレジットを受け取れます。',
  copyLink: 'リンクをコピー',
  copySuccess: 'コピーしました',
  copyDescription: '招待リンクをクリップボードにコピーしました',
  records: '招待履歴',
  noRecords: '招待履歴がありません',
  noRecordsDesc: '招待リンクを共有すると履歴が表示されます',
  user: 'ユーザー',
  pending: '承認待ち',
  pendingDescription: 'メール認証の完了を待っています',
  creditsAwarded: '+200 クレジット',
  usage: '利用状況',
  guide: 'クレジットをさらに獲得する',
  pricingFrom: '$20 から',
  clappingHandAlt: '拍手する手のイラスト',
  succeededDescription: '認証が完了し、200 クレジットが付与されました',
  howItWorks: {
    title: '使い方',
    steps: [
      '招待リンクを友達に共有する',
      '友達が登録してメール認証を完了する',
      '認証完了後にクレジットが付与される',
    ],
  },
};
export const landingUnsupportedMiscJa = {
  common: {
    error: 'エラー',
  },
  pricing: {
    breadcrumb: {
      home: 'ホーム',
      pricing: '料金',
    },
  },
  languageSwitcher: {
    aria_label: '言語',
  },
};
